import type { User } from 'c-entity-types';
import { baseInitialState, createBaseSlice } from 'c-data';
import type { UserState } from './user-types';

const initialState: UserState = { ...baseInitialState };

const additionalReducers = {
    // example: (state: UserState, action: PayloadAction<string>): UserState => state,
};

const slice = createBaseSlice<User, UserState, typeof additionalReducers>({
    name: 'user',
    entityName: 'User',
    initialState,
    reducers: additionalReducers,
});

const userSlice = {
    userActions: slice.slice.actions,
    userReducer: slice.slice.reducer,
    userAdapter: slice.adapter,
    userSelectors: slice.selectors,
    userThunks: slice.thunks,
};

export const { userReducer, userActions, userAdapter, userSelectors, userThunks } = userSlice;
